export const enum SearchParam {
  PROMO = 'promo',
}
